import React, { useEffect, useRef } from "react";
import ApexCharts from "apexcharts";
import { useSelector } from "react-redux";

const DonutChart = ({ title, target, achievement, icon, heightclass }) => {
  const chartRef = useRef(null);
  const chartInstance = useRef(null);

  useEffect(() => {
    if (!chartRef.current) return;

    const options = {
      chart: {
        type: "radialBar",
        height: 200,
      },
      series: [target, achievement],
      labels: ["Target", "Achievement"],
      plotOptions: {
        radialBar: {
          hollow: {
            size: "40%", // inner hole
          },
          track: { background: "#E0E0E0" },
          dataLabels: {
            name: {
              show: true,
              fontSize: "12px",
              color: "#666",
              offsetY: -10,
            },
            value: {
              show: true,
              fontSize: "16px",
              color: "#000",
              offsetY: 5,
              formatter: function (val) {
                return val + "%";
              },
            },
            total: {
              show: true,
              label: "Achievement",
              fontSize: "10px",
              color: "#666",
              formatter: function (w) {
                return achievement + "%";
              },
            },
          },
        },
      },
      colors: ["#EACB72", "#06513D"],
      legend: { show: false },
    };

    if (!chartInstance.current) {
      chartInstance.current = new ApexCharts(chartRef.current, options);
      chartInstance.current.render();
    } else {
      chartInstance.current.updateOptions(options);
    }

    return () => {
      if (chartInstance.current) {
        chartInstance.current.destroy();
        chartInstance.current = null;
      }
    };
  }, [target, achievement]);
  const { user } = useSelector((state) => state.auth);
  const isPermissionCompleted = user?.isCompleted;
  //console.log(isPermissionCompleted, "isPermissionCompleted");

  return (
    <div
      className={`${heightclass} pt-4 px-4 pb-0 rounded-2xl border border-[#3da3baa9] flex flex-col bg-white shadow-sm w-full max-w-full`}
    >
      <div className="flex items-center gap-2 mb-2">
        {icon}
        <h2 className="font-calibri font-semibold text-sm">{title}</h2>
      </div>

      <div
        className={`flex flex-col sm:flex-row items-center justify-between w-full gap-4 ${
          !isPermissionCompleted ? "blur-sm opacity-60 pointer-events-none" : ""
        }`}
      >
        <div ref={chartRef} className="w-full sm:w-[60%]"></div>

        <div className="w-full sm:w-[40%] flex flex-col justify-center gap-2">
          <div className="flex items-center gap-2">
            <div className="w-5 h-5 sm:w-6 sm:h-6 rounded-full bg-[#EACB72]"></div>
            <span className="text-[14px] sm:text-[15px]">
              Target - {target}%
            </span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-5 h-5 sm:w-6 sm:h-6 rounded-full bg-[#06513D]"></div>
            <span className="text-[14px] sm:text-[15px]">
              Achievement - {achievement}%
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DonutChart;
